<template>
  <div class="partner">
    <div class="partner_title">
      <div class="">合作机构</div>
    </div>
    <div v-for="(item, index) in tabList" :key="index">
      <div class="partner_name">{{ item.tab }}</div>
      <div class="partner_con wow animate__animated animate__slideInRight">
        <div
          :class="`parter_item_img ${item2.className}`"
          v-for="(item2, index2) in item.img"
          :key="index2"
          @click="go(item2.link)"
        >
          <img :src="item2.src" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      tabList: [
        {
          tab: "服务平台",
          id: "1",
          img: [
            { name: "华商银行", src: require("../../static/parter/p-25.jpg"

              ),link:'https://www.cmbcn.com.cn/' },
            { name: "新网银行", src: require("../../static/parter/p-xinwang.png"),link:'https://www.xwbank.com/',className:'widthAuto' },
            { name: "微众银行", src: require("../../static/parter/p_weizhong.png"),link:'https://www.webank.com/'},
            { name: "泉州银行", src: require("../../static/parter/quanzhouyinhang.jpg"),link:'https://www.qzccbank.com/'},
            { name: "富民银行", src: require("../../static/parter/fuminyinhang.png"),link:'https://www.fbank.com/'},
            { name: "厦门国际银行", src: require("../../static/parter/xiamenguojiyinhang.png"),link:'https://www.xib.com.cn/'},
            { name: "国寿财险", src: require("../../static/parter/p-guoshoucai.png"),link:'https://www.chinalife-p.com.cn/'},
            { name: "国任保险", src: require("../../static/parter/p-15.png") ,link:'https://www.guorenpcic.com/'},
            { name: "紫金保险", src: require("../../static/parter/p-10.png") ,link:'http://www.zking.com'},
            { name: "亚太财险", src: require("../../static/parter/p-17.jpg"),link:'https://www.apiins.com/maechannel/home.do' },
            { name: "阳光保险", src: require("../../static/parter/p-16.png"),link:'https://www.sinosig.com/' },
            { name: "中华保险", src: require("../../static/parter/p-zhonghua.png"),link:'https://www.cic.cn/' },
            { name: "泰康保险", src: require("../../static/parter/p-taikang.png"),link:'https://www.taikang.com/' },
            { name: "太平洋", src: require("../../static/parter/p-22.jpg"),link:'http://www.cpic.com.cn/' },
            { name: "中国平安", src: require("../../static/parter/p-9.jpg") ,link:'https://www.pingan.com'},
            { name: "中国人民", src: require("../../static/parter/p-19.jpg"),link:'https://www.picc.com/' },
           /* { name: "中国人寿", src: require("../../static/parter/p-20.jpg"),link:'https://www.chinalife.com.cn/chinalife/index/' },*/
            { name: "华泰保险", src: require("../../static/parter/p-23.png"),link:'https://www.ehuatai.com/' },
            {name: "华农财险", src: require("../../static/parter/hualongcaixian.png"), link: "https://www.chinahuanong.com.cn",},
            { name: "汇友财险", src: require("../../static/parter/p-huiyou.png"),link:'https://www.heromutual.com/' },
           /* { name: "安华农业保险", src: require("../../static/parter/p-12.png") ,link:'http://www.ahic.com.cn/'},*/
            /*{ name: "上海银行", src: require("../../static/parter/p-26.png"),link:'https://www.bosc.cn/zh/' },*/
            /*{ name: "民生银行", src: require("../../static/parter/p-27.png"),link:'http://www.cmbc.com.cn/' },*/
            { name: "中投保担保", src: require("../../static/parter/p-zhongtoubao.png") ,link:'https://www.guaranty.com.cn/gtztb/index.htm#firstPage'},
            { name: "瀚华担保", src: require("../../static/parter/hanhuadanbao.png") ,link:'https://www.hanhua.com/'},
            { name: "中关村", src: require("../../static/parter/p-28.jpg"),link:'http://www.cmbc.com.cn/' },
            { name: "银达富邦", src: require("../../static/parter/p-35.png"),link:'https://www.yinda2009.com/index/home' },
            { name: "星旺担保", src: require("../../static/parter/p-xingwang.png"),link:'http://www.hnxwdb.cn/' },
           /* { name: "渤海财险", src: require("../../static/parter/p-29.png"),link:'http://www.bpic.com.cn/' },*/
            /*{ name: "中国大地", src: require("../../static/parter/p-18.jpg"),link:'http://www.ccic-net.com.cn/' },*/
           /* { name: "国网英大", src: require("../../static/parter/p-14.png"),link:'http://www.ydjrw.sgcc.com.cn/' },*/

            // { name: "永诚", src: require("../../static/parter/p-24.jpg"),link:'https://www.alltrust.com.cn/' },
            // { name: "中国银行", src: require("../../static/parter/p-13.png"),link:'https://www.boc.cn' },
          ],
        },
        {
          tab: "业务平台",
          id: "2",
          img: [
          {
              name: "内蒙住建",
              src: require("../../static/parter/p-30.png"),
              link:'http://zjt.nmg.gov.cn/'
            },
            {
              name: "内蒙产权交易市场",
              src: require("../../static/parter/p-3.png"),
              link:'http://nmgcqjy.ejy365.com/'
            },
            {
              name: "内蒙古阳光采购服务平台",
              src: require("../../static/parter/p-36.jpg"),
              link:'http://nmgygcg.ejy365.com/'
            },
            {
              name: "中国通用招标网",
              src: require("../../static/parter/p-32.png"),
              link:'https://www.china-tender.com.cn/'
            },
            {
              name: "比德电子采购平台",
              src: require("../../static/parter/p-8.png"),
              link:'https://www.bdebid.com/'
            },
            {
              name: "内蒙招标采购",
              src: require("../../static/parter/p-31.png"),
              link:'https://imbpa.nmgztb.com.cn/'
            },
            {
              name: "新疆和田公共资源交易中心",
              src: require("../../static/parter/p-38.jpg"),
              link:'http://ggzy.xjht.gov.cn:8081/'
            },
            {
              name: "新疆阿勒泰公共资源交易中心",
              src: require("../../static/parter/p-39.jpg"),
              link:'http://xjaltggzy.gov.cn/tpfront/'
            },
            // { name: "e交易", src: require("../../static/parter/p-2.png") , link:'https://www.ejy365.com/'},

            // {
            //   name: "云采供",
            //   src: require("../../static/parter/p-34.png"),
            //   link:'http://ycg.86ztb.com/index.htm'
            // },
            {
              name: "中航发",
              src: require("../../static/parter/p-42.jpg"),
              link: "https://ebidding.aecc-mall.com/cms/index.htm",
            },

            {
              name: "华电",
              src: require("../../static/parter/p-41.png"),
              link: "https://www.chdtp.com/",
            },
            // {
            //   name: "黑龙江联合产权交易所",
            //   src: require("../../static/parter/p-4.png"),
            //   link:'http://www.huaee.net/'
            // },
            {
              name: "常州阳光交易市场",
              src: require("../../static/parter/p-5.png"),
              link:'http://www.czcq.com.cn/'
            },
            {
              name: "中航国际金网",
              src: require("../../static/parter/p-40.png"),
              link:'https://www.avicnet.cn/'
            },
            {
              name: "中国大唐集团",
              src: require("../../static/parter/datangjituan.png"),
              link:'https://www.china-cdt.com/'
            },
            {
              name: "中国通号",
              src: require("../../static/parter/zhongguotonghao.png"),
              link:'https://www.crscec.com/biddingManager/portal/index',
              className:'widthAuto'
            },
            {
              name: "丹东公共资源交易中心",
              src: require("../../static/parter/dandonggonggongziyuan.png"),
              link:'https://ddpas.dandong.gov.cn/ddggzy/',
              className:'width90'
            },
            {
              name: "国家电投官网",
              src: require("../../static/parter/guojiadiantou.png"),
              link:'https://espic.dlnyzb.com/',
              className:'widthAuto'
            },
            // {
            //   name: "北部湾产权交易所集团",
            //   src: require("../../static/parter/p-6.png"),
            //   link:'https://www.bbwcq.com/'
            // },
            // {
            //   name: "新疆维吾尔自治区住房和城乡建设厅",
            //   src: require("../../static/parter/p-7.png"),
            //   link:'http://zjt.xinjiang.gov.cn/'
            // },

          ],
        },
      ],
      tabIndex: 1,
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    chooseTab(e) {
      let tabIndex = e.target.dataset.tab;
      this.tabIndex = tabIndex;
    },
    go(url){
      window.open(url)
    }
  },
};
</script>

<style scoped >
.partner {
  width: 1200px;
  margin: auto;
}
.partner_title {
  width: 100%;
  font-size: 30px;
  text-align: center;
  margin-top: 100px;
}
.line {
  border-bottom: 3px solid rgb(26, 127, 221);
  color: rgb(26, 127, 221);
}
.partner_con {
  margin-top: 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
}
.partner_con > img {
  margin-right: 100px;
  margin-bottom: 30px;
  width: 200px;
}
.partner_name {
  border-left: 5px solid rgb(26, 127, 221);
  font-size: 30px;
  color: rgb(26, 127, 221);
  padding-left: 10px;
  height: 20px;
  line-height: 20px;
  margin: 30px 0;
}
.parter_item_img {
  width: 250px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin: 0 20px 20px 0;
  cursor: pointer;
}
.parter_item_img:hover {
  animation: pulse;
  animation-duration: 1.4s;
}
.parter_item_img img {
  width: 76%;
}
.widthAuto img{
  width: auto!important;
}
.width90 img{
  width: 90%!important;
}
</style>
